import { Cookies } from 'react-cookie';
import { serialize } from 'cookie';

const WITH_COOKIES = 'WITH_COOKIES';
const SET_COOKIE = 'Set-Cookie';
function getCtxCookieHeader(ctx) {
  let cookieHeader;
  if (ctx.req && typeof ctx.req.headers) {
    cookieHeader = ctx.req.headers.cookie;
  }
  return cookieHeader;
}
function setServerCookie(ctx, ...args) {
  const [name, value] = args;

  // set cookie on request for subsequent usage in later middleware
  ctx.req.cookies[name] = value;

  // serialize the cookie
  const cookie = serialize(...args);

  // handle multiple cookie setters by merging with any previous
  const prevCookies = [].concat(ctx.res.getHeader(SET_COOKIE)).filter(Boolean);
  const cookieValue = prevCookies.concat(cookie);

  // set the merged cookie header on the response
  ctx.res.setHeader(SET_COOKIE, cookieValue);
}
function withCtxCookies() {
  return ctx => {
    // only assign handlers if they have not been already assigned
    if (!ctx.__middleware.WITH_COOKIES) {
      ctx.cookies = {};
      ctx.cookies.get = function ctxCookiesGet(name) {
        const cookies = new Cookies(getCtxCookieHeader(ctx));
        return cookies.get(name);
      };
      ctx.cookies.set = function ctxCookiesSet(name, value, options = {}) {
        const cookies = new Cookies(getCtxCookieHeader(ctx));
        if (ctx.res) {
          setServerCookie(ctx, name, value, options);
        } else {
          cookies.set(name, value, options);
        }
      };
    }
    ctx.registerMiddleware(WITH_COOKIES);
  };
}

export { getCtxCookieHeader, setServerCookie, withCtxCookies };
